import qs from 'qs';
import request from '../utils/request';

// 数据统计
export const analysisStatistic = (id, params) => request(`/admin/analysis/${id}?${qs.stringify(params)}`);
// 排行
export const partnerRange = (id, params) => request(`/admin/analysis/range/${id}?${qs.stringify(params)}`);
// 热点数据
export const getHotPort = (params) => request(`/admin/analysis/hot/hot-port?${qs.stringify(params)}`);
// 柜子使用统计
export const cabUsage = (params) => request(`/admin/statistic/cab-usage?${qs.stringify(params)}`);
